import * as React from "react";
const SvgFiRrSocks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-socks_svg__a)">
      <path
        fill="#062147"
        d="M24.001 3.999a4.005 4.005 0 0 0-4-3.999h-11a3.97 3.97 0 0 0-2.829 1.172 3.98 3.98 0 0 0-1.17 2.83v1.006l.002 4.719c0 .25-.092.489-.26.674l-3.345 3.667c-2.109 2.636-1.796 6.469.696 8.544a6 6 0 0 0 3.837 1.39 6.04 6.04 0 0 0 3.517-1.144 6 6 0 0 0 3.483 1.144 5.95 5.95 0 0 0 4.663-2.222l4.212-4.861a9 9 0 0 0 2.197-5.897L24.002 4zm-2 0h-8c0-.534.208-1.036.585-1.414a2 2 0 0 1 1.415-.586h4c1.103 0 2 .897 2 2m-13-2h3.553a3.96 3.96 0 0 0-.553 2h-5c0-.534.208-1.036.585-1.414.378-.378.88-.586 1.415-.586M3.373 21.073c-1.66-1.383-1.847-3.966-.456-5.708l3.302-3.618a3 3 0 0 0 .784-2.024V5.999h5v3.724a1 1 0 0 1-.26.675l-3.345 3.667c-1.747 2.184-1.808 5.177-.368 7.324-1.414.859-3.365.758-4.656-.317zm16.921-5.465-4.237 4.891A3.98 3.98 0 0 1 12.931 22a4 4 0 0 1-2.558-.927c-1.66-1.383-1.847-3.966-.456-5.708l3.302-3.618a3 3 0 0 0 .784-2.024V5.999h8v5.021a7 7 0 0 1-1.709 4.586z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-socks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSocks;
